'use client'

import { PendingAppointmentsSection } from '@/components/layout/app-sidebar/pending-appointments-section'
import { Icon } from '@/components/ui/icon'
import { useMobilePortrait } from '@/hooks/use-mobile-portrait'
import { useAppDispatch, useAppSelector } from '@/lib/store'
import { setHidden } from '@/lib/store/features/pub-sidebar'
import { RootState } from '@/lib/store/store'
import { Button, Drawer } from "@heroui/react"
import React, { useCallback, useEffect } from 'react'

// Constants for localStorage keys
const SIDEBAR_HIDDEN_KEY = 'pub-sidebar-hidden'

export const AppSidebar: React.FC = () => {
  const dispatch = useAppDispatch()
  const isMobilePortrait = useMobilePortrait()
  const { isHidden } = useAppSelector((state: RootState) => state.pubSidebar)

  // Restore sidebar state from localStorage on component mount
  useEffect(() => {
    const savedState = localStorage.getItem(SIDEBAR_HIDDEN_KEY)
    if (savedState !== null) {
      dispatch(setHidden(JSON.parse(savedState)))
    }
  }, [dispatch])

  // Save sidebar state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SIDEBAR_HIDDEN_KEY, JSON.stringify(isHidden))
  }, [isHidden])

  const handleClose = useCallback(() => {
    dispatch(setHidden(true))
  }, [dispatch])

  const handleOpen = useCallback(() => {
    dispatch(setHidden(false))
  }, [dispatch])

  return (
    <>
      {/* Sidebar toggle button — hidden on mobile where FAB menu is used */}
      <Button
        onPress={handleOpen}
        isIconOnly
        variant="primary"
        size="sm"
        aria-label="Open navigation sidebar"
        className="fixed left-0 z-20 -translate-y-1/2 rounded-l-none rounded-r-full top-1/2 hidden md:flex"
      >
        <Icon icon="menu" className="w-5 h-5" />
      </Button>

      {/* Controlled state lives on Drawer.Backdrop and placement on Drawer.Content:
          v3 drops isOpen/onClose/placement/size/classNames passed to the root Drawer. */}
      <Drawer.Backdrop
        isOpen={!isHidden}
        onOpenChange={(open) => {
          if (!open) handleClose()
        }}
      >
        <Drawer.Content placement="left" className="max-w-[240px] w-[240px]">
          <Drawer.Dialog aria-label="Navigation sidebar">
            <Drawer.Header className="flex items-center justify-between p-3">
              <Drawer.Heading className="text-base font-bold">History</Drawer.Heading>
            </Drawer.Header>

            <Drawer.Body className="p-0 overflow-y-auto">
              <div className="w-full mx-auto">
                <PendingAppointmentsSection isCompact={false} />
              </div>
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </>
  )
}

